import React from "react";
import Item from "./Item";

export default function EventScaleScreen(props) {
    let cards = [];
    props.screenCastMarkup.result.map(element => {
        const body = [[],[]];
        let warn = ""
        element.warn.map(elem => {
            body[0].push(elem);
            //console.log(elem);
            warn += String(elem)
        });
        element.ok.map(elem => {
            body[1].push(elem);
            //console.log(elem);
        });
            //console.log(body)
            //Entering violations into an array for sorting
            cards.push(<Item 
                token={props.token}
                key={`${element.start_time}-${element.end_time}`}
                source="window"
                from={element.start_time}
                to={element.end_time}
                duration={element.end_time - element.start_time}
                body={body}
                setViolation={props.setViolation}
            />);
            
            
    })

    //sorting the array using the sort method that the comparator accepts
    //Sorting by duration of violation
    cards.sort(function(a,b){return (b.props.duration - a.props.duration)});
    //console.log(cards);

    //we will return the sorted array of violations
    return (<>
        {cards}
    </>
    );
}
